import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faHeart, faShoppingCart, faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartO } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { GradeCard } from "../../components/containers/grade-card";
import { CartAddForm } from "../../components/utils/cart-add-form";
import { DarkBg } from "../../components/containers/dark-bg";
import { InviewAnim } from "../../components/utils/animations";
import { loadCartItems } from "../../_helpers/cart.methods";
import { inventory } from "../../_helpers/mock-data";
import { formatImageUrl } from "../../_helpers/route-image";
import { useProduct } from "../../../services/products/product.context";
import { AboutComponent } from "../../components/containers/about";
import { FooterComponent } from "../../components/footer/footer";

export const DetailsPage = () => {

    const item = useLocation().state;

    const navigateTo = useNavigate();

    const { cart, wishList, addTocart, addTowishList } = useProduct();

    const [currentSlide, setCurrentSlide] = useState(0);
    const [openCart, setOpenCart] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [cartQuantity, setCartQuantity] = useState(0);

    const increment = () => setQuantity((v) => v + 1)
    const decrement = () => {
        if (quantity === 1) return;
        setQuantity((v) => v - 1);
    }


    const scrolltoElement = (id) => {
        const element = document.getElementById(id);
        element.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        })
    }

    const toNext = () => {
        if (currentSlide < item?.images?.length - 1) {
            setCurrentSlide(curr => curr + 1);
            glideToslide(currentSlide + 1);
        }

    }

    const toPrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide(curr => curr - 1);
            glideToslide(currentSlide - 1);
        }
    }

    const glideToslide = (slideIndex) => {
        const element = document.getElementById(slideIndex);
        element.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }



    const inCart = (product) => {
        return cart?.some((obj) => obj._id === product?._id);
    }

    const inWishList = (product) => {
        return wishList?.some((obj) => obj._id === product?._id);
    }

    const handleCheckout = (item) => {
        const productList = [{
            designation: item?.designation,
            quantity,
            price:
                (item?.pricing?.original_cost - item?.pricing?.original_cost * item?.pricing?.discount) * quantity
        }];
        navigateTo("/fr/checkout", {
            state: {
                products: productList,
                total: productList[0].price
            }
        });
    }



    useEffect(() => {
        const getCartQuantity = (item) => {
            const itemObject = cart?.find((obj) => obj._id === item?._id);
            if (itemObject) {
                return itemObject.quantity;
            }
            return 0;
        }
        if (!cart || cart.length === 0) {
            setCartQuantity(0);
            return;
        }
        const qty = getCartQuantity(item);
        setCartQuantity(qty);
    }, [item, cart])

    return (
        <div className="app-body">
            <SiteHeader pageTitle={item?.designation} />
            {openCart && (
                <DarkBg onClose={() => setOpenCart(false)}>
                    <CartAddForm
                        itemData={item}
                        closeCart={() => setOpenCart(false)}
                        opened={openCart}
                        cart={cart}
                    />
                </DarkBg>
            )}

            <div className="details-section">
                <div>
                    <div className="details-images" >
                        <div className="image-scroll-box">
                            <div className="scroll-buttons-box">
                                <button
                                    className="scroll-buttons tr-btn"
                                    onClick={toPrev}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                <button
                                    className="scroll-buttons tr-btn"
                                    onClick={toNext}
                                >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                        {item?.images?.map((image, indx) => (
                            <img src={formatImageUrl(image)} alt="" className="details-image" key={indx} id={indx} />
                        ))}
                    </div>
                    <div className="row-box">
                        <div className="left-row">
                            <div className="item-caption">{item?.designation}</div>
                            <div className="item-det-cost">
                                {item?.pricing?.discount > 0 &&
                                    <strike style={{ color: "#888888" }}>
                                        <div className="discount-box" style={{ color: "#888888" }}>
                                            FCFA {item?.pricing?.original_cost}
                                        </div>
                                    </strike>
                                }
                                <div className="cost-box">
                                    FCFA {item?.pricing?.original_cost - item?.pricing?.original_cost * item?.pricing?.discount}
                                </div>
                            </div>
                        </div>

                        <div className="right-row">
                            <button
                                className="act-button list-add"
                                onClick={() => addTowishList(item)}
                            >
                                <FontAwesomeIcon
                                    icon={inWishList(item) ? faHeart : faHeartO}
                                />
                            </button>
                            <button
                                className="act-button cart-add"
                                onClick={() => {
                                    setOpenCart(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faShoppingCart} />
                                {cartQuantity > 0 &&
                                    <span className="cart-qty">
                                        {cartQuantity}
                                    </span>
                                }
                            </button>
                        </div>
                    </div>
                    <div className="pics-prev">
                        {item?.images?.map((image, K) => (
                            <div
                                className={classNames("image-frame", { 'selected': currentSlide === K })}
                                key={K}
                                onClick={() => {
                                    setCurrentSlide(K);
                                    scrolltoElement(K)
                                }}
                            >
                                <img src={(formatImageUrl(image))} alt="" className="sm-image" />
                            </div>
                        ))}
                    </div>
                </div>
                <GradeCard
                    data={item}
                />
                <div className="cart-object-actions det-order">
                    <div className="quantity-area">
                        <button className="q-button" onClick={decrement}>
                            <FontAwesomeIcon icon={faMinus} />
                        </button>
                        <input
                            type="number"
                            onChange={(e) => setQuantity(e.target.value)}
                            value={quantity}
                            className="q-input"
                        />
                        <button className="q-button" onClick={increment}>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </div>
                    <div className="item-sub-total">
                        <span className="sub-caption">Total</span>
                        <span className="sub-amount">
                            FCFA{" "}
                            {((item?.pricing?.original_cost - item?.pricing?.original_cost * item?.pricing?.discount) * quantity).toLocaleString()}
                        </span>
                    </div>
                </div>
                <div
                    className="order-button-box"
                    onClick={() => {
                        handleCheckout(item);
                    }}
                >
                    <button className="final-order-button">Passez votre commande</button>
                </div>
            </div>
            <AboutComponent />
            <FooterComponent />
        </div>
    )
}